module.exports = __webpack_public_path__ + "media/images/chrome-43dda993cd2174b5f40c8ba248e0c760.svg";